import { CheckCircleFilled, MailOutlined } from '@ant-design/icons';
import { Button, Card, Flex, Form, Input, Typography } from 'antd';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { useForgotPassword } from '../hooks/useAuthQueries';
import { ROUTES } from '../routes/routes';

const { Title } = Typography;

const Wrapper = styled(Flex)`
  min-height: 100vh;
  background: #f4f7f6;
  justify-content: center;
  align-items: center;
`;

const StyledCard = styled(Card)`
  width: 460px;
  border-radius: 16px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;
  border: 1px solid #edf2f7 !important;

  .ant-card-body {
    padding: 36px 40px !important;
  }
`;

const LogoMark = styled.div`
  text-align: center;
  margin-bottom: 8px;
  font-size: 24px;
  font-weight: 800;
  color: #ff8e8e;
  letter-spacing: 1px;
`;

const PageTitle = styled(Title)`
  text-align: center !important;
  margin: 0 0 24px !important;
`;

const SuccessState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 8px 0 16px;
  text-align: center;
`;

const SuccessIcon = styled(CheckCircleFilled)`
  font-size: 48px;
  color: #52c41a;
`;

const SuccessText = styled.p`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  line-height: 1.6;
  margin: 0;
`;

const BackLink = styled(Link)`
  display: block;
  text-align: center;
  margin-top: 12px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.45);

  &:hover {
    color: #ff8e8e;
  }
`;

export const ForgotPasswordPage: React.FC = () => {
  const [submitted, setSubmitted] = useState(false);
  const { mutate, isPending } = useForgotPassword();

  const handleSubmit = ({ email }: { email: string }) => {
    mutate({ email }, { onSettled: () => setSubmitted(true) });
  };

  return (
    <Wrapper>
      <StyledCard>
        <LogoMark>AVON MARKET</LogoMark>
        <PageTitle level={4}>Забули пароль?</PageTitle>

        {submitted ? (
          <SuccessState>
            <SuccessIcon />
            <SuccessText>
              Якщо обліковий запис з таким email існує, ми надіслали інструкції для скидання пароля.
            </SuccessText>
          </SuccessState>
        ) : (
          <Form layout="vertical" onFinish={handleSubmit} autoComplete="off">
            <Form.Item
              name="email"
              rules={[
                { required: true, message: 'Введіть email' },
                { type: 'email', message: 'Невірний формат email' },
              ]}
            >
              <Input prefix={<MailOutlined />} placeholder="Email" size="large" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={isPending} block size="large">
                Надіслати посилання
              </Button>
            </Form.Item>
          </Form>
        )}

        <BackLink to={ROUTES.LOGIN}>Повернутися до входу</BackLink>
      </StyledCard>
    </Wrapper>
  );
};
